import { styled } from '@mui/material/styles';
import { Switch } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

export const CustomSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      icon={<CloseIcon sx={{ fontSize: 14, color: '#fff' }} />}
      checkedIcon={<CheckIcon sx={{ fontSize: 14, color: '#63e206' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    width: 40,
    height: 22,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        color: '#fff',
        background: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#64DD16',
          opacity: 1,
          border: '2px solid #63e206',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#6c6671',
      width: 21,
      height: 21,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
    },
    '& .MuiSwitch-track': {
      borderRadius: 28 / 2,
      backgroundColor: '#e5dfe9',
      opacity: 1,
      border: '2px solid #79747E',
    },

    '@media screen and (max-width: 1280px)': {
        width: 32,
        height: 18,
        '& .MuiSwitch-switchBase': {
          '&.Mui-checked': {
            transform: 'translateX(16px)',
          },
        },
        '& .MuiSwitch-thumb': {
          width: 16,
          height: 16,
        },
      },
      
  }));
  